import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { toast } from "sonner";
import { MobileShell } from "@/components/MobileShell";
import { Wordmark, Button, Field, Input } from "@/components/kit";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/app/discover");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MobileShell>
      <div className="px-7 pt-6 pb-10 min-h-screen flex flex-col">
        <button onClick={() => navigate("/welcome")} className="text-[#5F6D66] -ml-2 p-2 w-fit" data-testid="login-back-btn">
          <ChevronLeft className="h-5 w-5" />
        </button>
        <div className="mt-6 lg:mt-2">
          <Wordmark className="lg:hidden" />
          <h1 className="font-serif text-3xl text-[#1F2B26] mt-8 lg:mt-2">Welcome back</h1>
          <p className="font-sans text-sm text-[#5F6D66] mt-2">Sign in to continue your conversations.</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <Field label="Email">
            <Input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="login-email-input" />
          </Field>
          <Field label="Password">
            <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password" data-testid="login-password-input" />
          </Field>
          {error && <p className="font-sans text-sm text-[#9B4B45]" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full" size="lg" disabled={loading} data-testid="login-submit-btn">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <div className="mt-6 text-center space-y-3">
          <Link to="/forgot-password" className="font-sans text-sm text-[#253B35] underline underline-offset-2" data-testid="login-forgot-link">
            Forgot your password?
          </Link>
          <p className="font-sans text-sm text-[#5F6D66]">
            New to Sincerr?{" "}
            <Link to="/register" className="text-[#253B35] font-medium underline underline-offset-2" data-testid="login-to-register-link">Create an account</Link>
          </p>
        </div>
      </div>
    </MobileShell>
  );
}
